import { IconName } from "./__generated__/IconName"

export const EDITOR_ICONS = [
  IconName.APPS,
  IconName.PROJECTS,
  IconName.PRODUCTS,
  IconName.USER,
  IconName.CONFIGURATION,
  IconName.BUILDING,
  IconName.HEART,
  IconName.COMMENT,
  IconName.TEAM_ADD,
  IconName.FOLDER_COPY,
  IconName.PORTFOLIO,
  IconName.BAR_CHART,
  IconName.LIGHT_BULB,
  IconName.SMALL_CARET_UP,
  IconName.SMALL_CARET_DOWN,
  IconName.SMALL_CARET_LEFT,
  IconName.SMALL_CARET_RIGHT
] as const
